<template>
  <div class="container py-4 py-lg-5 my-lg-5 px-4 px-sm-0">
    <div class="row">
      <div class="col col-md-4 col-lg-4 hidden-sm-down">
        <img
          src="/img/logo-scm.svg"
          class="w-100 opacity-20"
          aria-roledescription="logo"
          :alt="appTitle"
        />
      </div>

      <div class="col-sm-12 col-md-8 col-lg-8 col-xl-7 ml-auto">
        <div class="card p-4 rounded-0 bg-faded">
          <h1 class="h2 text-left fw-600 mb-4 d-xs-block">{{ $t('titles.forgot-password') }}</h1>

          <div class="mb-4 label">
            {{ $t('text.reset-password-part-1') }}
            <b>{{ $t('text.reset-password-part-2') }}</b>
            {{ $t('text.reset-password-part-3') }}
            <b class="text-nowrap">{{ $t('text.reset-password-part-4') }}</b>&nbsp;
            <b class="text-nowrap">{{ $t('text.reset-password-part-5') }}</b>
          </div>

          <form @submit.prevent="submit">
            <div class="form-group">
              <w-input :model="$schema.email" />
            </div>

            <div class="col-sm-12 text-right">
              <button
                type="submit"
                class="btn btn-smart btn-lg rounded-pill"
              >{{ $t('buttons.send') }}</button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { formMixin } from '@/mixins/form';
import { notificationsMixin } from '@/mixins/notifications';
import { authResource } from '@/resources/auth.resource';
import schema from '@/schemas/resetPassword.schema';

// @vuese
// Resetowanie hasła
// @group Start
export default {
  name: 'Reset',
  mixins: [formMixin, notificationsMixin],
  schema,
  data() {
    return {
      model: {
        email: ''
      }
    };
  },
  methods: {
    // @vuese
    // Wysyła maila z resetem hasła
    submit() {
      if (!this.$schema.$validateAll().length) {
        authResource
          .resetPassword(this.model.email)
          .then(() =>
            this.$store.dispatch('showConfirm', {
              title: this.$t('titles.resetPasswordMessage'),
              showCloseButton: false,
              submitButton: 'Ok',
              onSuccess: () => this.$router.push({ name: 'login' })
            })
          )
          .catch(err => this.notifyError(err.message || 'messages.errorLong'));
      }
    }
  },
  computed: mapState({
    appTitle: state => state.system.appTitle
  })
};
</script>
